import { hideableLayoutContextMenuItems, hideableLayoutFunc } from './hideable-layout.js';

const layoutConfig = {
	tagName: 'HideableLayout',
	key: 'layoutHideableLayout',
	contextMenuItems: hideableLayoutContextMenuItems,
	func: hideableLayoutFunc,
	title: { desc: 'Sankey6', name: 'Layout' },
	children: [
		{
			tagName: 'VerticalLayout',
			children: [
				{
					tagName: 'Text',
					text: { desc: 'Sankey7', name: 'Node Align' }
				},
				{
					tagName: 'Radio',
					horizontal: true,
					key: 'nodeAlignment',
					className: 'toggle-button-radio _3item',
					innerClassName: 'sankey-node-alignment-icons',
					options: [
						{
							name: 'left',
							value: 'left',
							tooltipText: { desc: 'Sankey28', name: 'Left Aligned' }
						},
						{
							name: 'middle',
							value: 'middle',
							tooltipText: { desc: 'Sankey49', name: 'Justified' }
						},
						{
							name: 'right',
							value: 'right',
							tooltipText: { desc: 'Sankey29', name: 'Right Aligned' }
						}
					],
					useButtons: true,
					useIcons: true,
					useTooltips: true
				}
			]
		},
		{
			tagName: 'VerticalLayout',
			children: [
				{
					tagName: 'Checkbox',
					checked: false,
					key: 'isReverseGraphEnabled',
					text: { desc: 'Sankey8', name: 'Reverse the graph' }
				},
				{
					tagName: 'Checkbox',
					checked: false,
					key: 'showLevelName',
					text: { desc: 'Sankey9', name: 'Show level names' }
				},
				{
					tagName: 'Checkbox',
					checked: false,
					key: 'isVerticalScrollEnabled',
					text: { desc: 'Sankey10', name: 'Enable vertical scroll' }
				}
			]
		},
		{
			tagName: 'HorizontalLayout',
			className: 'horizontal-flex-space-between',
			children: [
				{
					tagName: 'Text',
					text: { desc: 'Sankey11', name: 'Dragging of items' }
				},
				{
					tagName: 'Text',
					className: 'sankey-dnd-icon'
				},
				{
					tagName: 'Switch',
					key: 'isDraggingOfNodesEnabled'
				}
			]
		},
		{
			tagName: 'HorizontalLayout',
			className: 'horizontal-flex-space-between',
			children: [
				{
					tagName: 'Text',
					text: { desc: null, name: '' }
				},
				{
					tagName: 'Button',
					text: { desc: 'Sankey12', name: 'Reset' },
					key: 'resetCachedNodes'
				}
			]
		},
		{ tagName: 'Divider' }
	]
};

export default layoutConfig;
